
/* Config */
import { i18n, setHtmlPageLang } from '@/config/plugins/in18setup'
import { useLocaleStoreWithOut } from '../store/locale';


type I18nGlobalTranslation = {
    (key: string): string
    (key: string, locale: string): string
    (key: string, locale: string, list: unknown[]): string
    (key: string, locale: string, named: Record<string, unknown>): string
    (key: string, list: unknown[]): string
    (key: string, named: Record<string, unknown>): string
}

type I18nTranslationRestParameters = [string, any]


const getKey = (namespace: string | undefined, key: string) => {

    if (!namespace) {

        return key

    }
    if (key.startsWith(namespace)) {

        return key

    }

    return `${namespace}.${key}`

}

export const useLocales = (namespace?: string): { t: I18nGlobalTranslation } => {

    const normalFn = {

        t: (key: string) => {

            return getKey(namespace, key)

        }

    }

    if (!i18n) {

        return normalFn

    }

    const { t, ...methods } = i18n.global

    const tFn: I18nGlobalTranslation = (key: string, ...arg: any[]) => {

        if (!key) return ''

        if (!key.includes('.') && !namespace) return key

        return (t as any)(getKey(namespace, key), ...(arg as I18nTranslationRestParameters))

    }

    return { ...methods, t: tFn }
}

export const t = (key: string) => key

const setI18nLanguage = (locale: LocaleType) => {

    const localeStore = useLocaleStoreWithOut()

    if (i18n.mode === 'legacy') {

        i18n.global.locale = locale

    } else {

        (i18n.global.locale as any).value = locale

    }

    localeStore.setCurrentLocale({ lang: locale })

    setHtmlPageLang(locale)

}


export const useLocaleChange = () => {

    const changeLocale = async (locale: LocaleType) => {

        const globalI18n = i18n.global

        const langModule = await import(`../locales/${locale}.ts`)

        globalI18n.setLocaleMessage(locale, langModule.default)

        setI18nLanguage(locale)

    }

    return { changeLocale }
}
